var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"py-3 bg-secondary"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"tx-18 text-white"},[_vm._v(_vm._s(_vm.comp.task))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }